import React from 'react';

import './styles.css';

const CONFIRMED = 'Confirmed';
const CANCELLED = 'Cancelled';
const RESERVED = 'Reserved';
const NO_SHOW = 'No show';
const OVERSTAY = 'Overstay';
const DUE_OUT = 'Due out';
const IN_HOUSE = 'In house';
const CHECKED_OUT = 'Checked out';
const DUE_IN = 'Due in';
const QUALIFIED = 'Qualified';

interface BookingStatusTagProps {
  status: string;
}

const STATUS_TO_COLOR_MAPPER = {
  [CONFIRMED]: {
    backgroundColor: '#D4F1CA',
    textColor: '#228100',
    borderColor: '#5FBA3F'
  },
  [CANCELLED]: {
    backgroundColor: '#E1E8F0',
    textColor: '#6E7B8C',
    borderColor: '#d2d9e2'
  },
  [RESERVED]: {
    backgroundColor: '#FFE6C2',
    textColor: '#E96200',
    borderColor: '#FF9626'
  },
  [NO_SHOW]: {
    backgroundColor: '#FFC6E2',
    textColor: '#BB427E',
    borderColor: '#BB427E'
  },
  [OVERSTAY]: {
    backgroundColor: '#FF4444',
    textColor: '#FFFFFF',
    borderColor: '#FF4444'
  },
  [DUE_OUT]: {
    backgroundColor: '#FFC9C9',
    textColor: '#C14747',
    borderColor: '#C14747'
  },
  [IN_HOUSE]: {
    backgroundColor: '#CCEBFF',
    textColor: '#0C6AA6',
    borderColor: '#0C6AA6'
  },
  [CHECKED_OUT]: {
    backgroundColor: '#FFE1E1',
    textColor: '#AB4F4F',
    borderColor: '#AB4F4F'
  },
  [DUE_IN]: {
    backgroundColor: '#49EEE9',
    textColor: '#006A67',
    borderColor: '#006A67'
  },
  [QUALIFIED]: {
    backgroundColor: '#FFCB9C',
    textColor: '#BE6700',
    borderColor: '#BE6700'
  }
};

const BookingStatusTag = ({status}: BookingStatusTagProps) => {
  const {backgroundColor, textColor, borderColor} = STATUS_TO_COLOR_MAPPER[
    status
  ];

  return (
    <div
      className="BookingStatusTag colab-centered colab-bold"
      style={{
        backgroundColor,
        borderColor,
        color: textColor
      }}>
      {status}
    </div>
  );
};

export default BookingStatusTag;
